import { IPrismicRichText, IPrismicImage } from '@monofront/types';
import { IPrismicLink } from '@monofront/types';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

export type HeroBannerProps = SliceComponentProps<Content.HeroBannerSlice>;

export enum HERO_BANNER_TYPE {
  DEFAULT = 'Default',
  WITH_EMAIL_FIELD = 'With email field',
}

export interface IHeroBanner {
  bgDesktopImg: IPrismicImage;
  bgMobileImg: IPrismicImage;
  ctaDesc: IPrismicRichText;
  ctaLabel?: string;
  ctaLink: IPrismicLink;
  desc: IPrismicRichText;
  title: IPrismicRichText;
  ctaLabelFinishSubscription: string;
  type: HERO_BANNER_TYPE;
}
